import { rasterSrc } from "@/generated/raster-images";
import { createFileRoute } from "@tanstack/react-router";
import { PageHero, Section } from "@/components/site-blocks";
import { pageSeo } from "@/lib/seo";

export const Route = createFileRoute("/data-protection")({
  head: () => ({
    ...pageSeo({
      path: "/data-protection",
      title: "Data Protection | CRS Energy",
      description: "Our commitments to data protection under UK GDPR.",
    }),
  }),
  component: DataProtectionPage,
});

function DataProtectionPage() {
  return (
    <>
      <PageHero eyebrow="Legal" title="Data Protection" description="Our commitments to data protection under UK GDPR." image={rasterSrc("stock/photo-1573164574511-73c773193279")} imageAlt="" />
      <Section>
        <div className="max-w-3xl space-y-6">
          
          {[
            { title: "Lawful basis", body: "We process your data on the basis of legitimate interest (responding to your enquiries) and contract (delivering work you commission)." },
            { title: "Data retention", body: "Enquiry data is retained for 24 months unless we have an active contractual or warranty relationship with you, in which case it is retained for the duration plus 7 years." },
            { title: "Data security", body: "All data is stored on UK or EEA infrastructure with industry-standard encryption at rest and in transit. Access is restricted to authorised personnel." },
            { title: "Your rights under UK GDPR", body: "Right of access, rectification, erasure, restriction, portability, and objection. Contact us to exercise any of these rights." },
            { title: "Complaints", body: "If you are unhappy with how we have handled your data, you have the right to complain to the Information Commissioner's Office at ico.org.uk." },
          ].map((s) => (
            <div key={s.title}>
              <h2 className="text-xl font-semibold">{s.title}</h2>
              <p className="mt-2 text-muted-foreground">{s.body}</p>
            </div>
          ))}
        </div>
      </Section>
    </>
  );
}
